import { oids } from "@/configs/Settings";
import dayjs from "dayjs";

interface ContractBodyParams {
  provider: string;
  apiKey: string;
  cpf: string;
  nome: string;
  email: string;
  organizationId: string;
  identifier: string;
}

export function buildContractBody({
  provider,
  apiKey,
  cpf,
  nome,
  email,
  organizationId,
  identifier,
}: ContractBodyParams) {
  return {
    resourceType: "Contract",
    extension: [
      {
        url: `https://fluxmed.com.br/fhir/extension/${identifier.toLowerCase()}/provider`,
        valueString: provider,
      },
      {
        url: `https://fluxmed.com.br/fhir/extension/${identifier.toLowerCase()}/api-key`,
        valueString: apiKey,
      },
      {
        url: `https://fluxmed.com.br/fhir/extension/${identifier.toLowerCase()}/cpf`,
        valueString: cpf,
      },
      {
        url: `https://fluxmed.com.br/fhir/extension/${identifier.toLowerCase()}/nome`,
        valueString: nome,
      },
      {
        url: `https://fluxmed.com.br/fhir/extension/${identifier.toLowerCase()}/email`,
        valueString: email,
      },
    ],
    identifier: [
      {
        system: "https://fluxmed.com.br/hapi/fhir/R5/contract-types",
        value: identifier,
      },
    ],
    status: "executed",
    authority: [
      {
        reference: `Organization/${oids?.cnpj}-${organizationId}`,
      },
    ],
    type: {
      coding: [
        {
          system: "https://fluxmed.com.br/hapi/fhir/R5/contract-types",
          code: identifier,
        },
      ],
    },
    term: [
      {
        identifier: {
          system: "https://fluxmed.com.br/hapi/fhir/R5/contract-terms",
          value: identifier,
        },
        issued: dayjs().subtract(3, 'hours').toISOString(),
        applies: {
          start: dayjs().subtract(3, 'hours').toISOString(),
        },
        text: "Contrato de extensão para utilização de Inteligência Artificial",
        offer: {
          type: {
            coding: [
              {
                system:
                  "https://fluxmed.com.br/hapi/fhir/R5/contract-offer-types",
                code: "subscription",
              },
            ],
          },
        },
        asset: [
          {
            valuedItem: [
              {
                entityCodeableConcept: {
                  coding: [
                    {
                      system:
                        "https://fluxmed.com.br/hapi/fhir/R5/subscription-types",
                      code: "subscription-fee",
                    },
                  ],
                },
                quantity: {
                  value: 1,
                  unit: "subscription",
                },
                unitPrice: {
                  value: 0,
                  currency: "BRL",
                },
              },
            ],
          },
        ],
      },
    ],
  };
} 